import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';

type TransferCountrySources = {
  bankAccount?: TransferContextData['bankAccount'];
  user?: {
    physicalAddress?: { country?: string | null } | null;
    countryOfTaxResidence?: string | null;
  } | null;
  organizationCountries: string[];
};

export const resolveTransferCountry = ({
  bankAccount,
  user,
  organizationCountries,
}: TransferCountrySources) =>
  bankAccount?.bankAccountTransitPhysicalAddress?.country ||
  user?.physicalAddress?.country ||
  user?.countryOfTaxResidence ||
  organizationCountries[0];
